import { Badge, IconButton, Icons, Tooltip } from '@commenda/kakashi';
import { IChatRooms } from '@commenda/types';
import { ChatRoomModel } from '@commenda/utils';

type ChatRoomRowProps = {
  chatRoom: IChatRooms['chatRooms'][0];
  onSelectChatRoomId: (chatRoomId: string) => void;
  showBusinessEntityName: boolean;
};

export const ChatRoomRow = ({
  chatRoom,
  onSelectChatRoomId,
  showBusinessEntityName,
}: ChatRoomRowProps) => {
  const totalUnread = ChatRoomModel.getTotalUnread(chatRoom);
  const isGeneralThread = chatRoom.type === 'GENERAL_THREAD';
  const displayName = isGeneralThread
    ? 'Account Manager'
    : chatRoom.chatRoomName;

  return (
    <div
      className={`flex items-center justify-between p-xl cursor-pointer hover:bg-bg-primary-hover transition-all${isGeneralThread ? ' bg-bg-secondary' : ''}`}
      onClick={() => onSelectChatRoomId(chatRoom.id)}
    >
      <div className="flex items-center gap-md">
        {isGeneralThread && (
          <Icons.MessageCircle01 className="size-4 text-text-tertiary shrink-0" />
        )}
        <span className="text-text-primary txt-small-medium shrink-0">
          {displayName}
        </span>
        {showBusinessEntityName && chatRoom.businessEntity?.name && (
          <>
            <span className="text-fg-secondary">•</span>
            <span className="text-text-tertiary txt-small-regular truncate">
              {chatRoom.businessEntity.name}
            </span>
          </>
        )}
      </div>
      <div className="flex items-center gap-lg">
        {totalUnread > 0 && (
          <Badge size="sm" variant="blue">
            {totalUnread}
          </Badge>
        )}
        <Tooltip content="View messages" side="right">
          <IconButton
            icon={<Icons.ChevronRight />}
            size="sm"
            aria-label="View messages"
          />
        </Tooltip>
      </div>
    </div>
  );
};
